const HomeLogo = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg 
      width={24} 
      height={24} 
      viewBox="0 0 64 64" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m62.57726 22.85596-28.53449-20.80585c-1.22479-.89307-2.86542-.89307-4.08423 0l-28.53686 20.80707c-1.54327 1.12622-1.88342 3.29816-.7572 4.84143l3.64911 5.00494c.67792.92792 1.73444 1.42194 2.80536 1.42194.70795 0 1.42194-.21637 2.03613-.66467l.07489-.05463v24.89349c0 2.38 1.94 4.32001 4.32001 4.32001h36.89001c2.39001 0 4.33002-1.94 4.33002-4.32001v-21.58001c0-.67999-.55005-1.22998-1.23004-1.22998s-1.22998.54999-1.22998 1.22998v21.58002c0 1.02002-.84003 1.85999-1.87 1.85999h-9.28644v-17.14692c0-2.01447-1.63947-3.65393-3.65393-3.65393h-11.0003c-2.01447 0-3.65277 1.63947-3.65277 3.65393v17.14691h-9.29657c-1.01996 0-1.85999-.83997-1.85999-1.85999v-26.68731l20.30945-14.80945 22.84442 16.65912c1.54572 1.125 3.71643.78247 4.84387-.75964l3.64917-5.00378c1.125-1.54573.78363-3.71766-.75964-4.84266zm-37.2691 20.1568c0-.65625.53491-1.19232 1.19116-1.19232h11.00031c.65625 0 1.19232.53607 1.19232 1.19232v17.14471h-13.38379zm36.03826-16.76368-3.64673 5.0025c-.32935.44836-.96155.53973-1.40387.22119l-23.57159-17.18676c-.4303-.31494-1.01923-.31494-1.44952 0l-23.56922 17.18555c-.44592.32452-1.07574.23077-1.40387-.21875l-3.64795-5.00372c-.3269-.44714-.22833-1.07697.21881-1.40393l28.53565-20.80707c.17664-.1286.38458-.19348.59253-.19348.20673 0 .41467.06488.59137.19348l28.53326 20.80707v.00122c.44953.32574.5481.95556.22113 1.4027z"
        fill="inherit"
      />
    </svg>
  );
};

export default HomeLogo;

